class ExportAiCostWorkbook {
	constructor(
		public readonly accountId: number,
		// Already composed by the `AiCostsFilterView` (`from`, `to`, axis filters, `sort`).
		public readonly queryParams: URLSearchParams,
	) {
		Object.freeze(this);
	}

	toQueryString(): string {
		return this.queryParams.toString();
	}

	/**
	 * Composed client-side from the requested period, ASCII only, no accent, no whitespace — the
	 * only shape `Domain/Api.ts` can parse out of `Content-Disposition`. It is the last resort, not
	 * a formality: a credentialed CORS response only exposes a header listed in `exposedHeaders`,
	 * and no test in this repository — neither MSW nor supertest — simulates CORS, so a regression
	 * on the server's `exposedHeaders` line would go undetected without this fallback.
	 */
	get fallbackFilename(): string {
		const startDate = this.queryParams.get('from')?.slice(0, 10) ?? 'periode';
		const endDate = this.queryParams.get('to')?.slice(0, 10) ?? 'inconnue';

		return `couts-ia-${startDate}-au-${endDate}.xlsx`;
	}
}

export default ExportAiCostWorkbook;
